interface UserDetails {
  email: string;
  name: string;
  id: number;
  'g-recaptcha-response': string;
}
export class User {
  private static userData;

  static setUser(data: UserDetails) {
    User.userData = data;
  }

  static getUser() {
    return User.userData;
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/models/user.ts